import { render, staticRenderFns } from "./detrecomaudio.vue?vue&type=template&id=3baedc1c&"
import script from "./detrecomaudio.vue?vue&type=script&lang=js&"
export * from "./detrecomaudio.vue?vue&type=script&lang=js&"
import style0 from "./detrecomaudio.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports